import { useInfiniteQuery } from '@tanstack/react-query';
import { useModuleByCodeParam } from '@shared/hooks/use-module-by-code-param.ts';
import { API } from '@src/api/index.ts';
import { ProgramsListParams } from '@src/api/programs.ts';

export const useProgramsInfiniteQuery = (params: Omit<ProgramsListParams, 'page' | 'module'>) => {
  const { moduleId } = useModuleByCodeParam();
  return useInfiniteQuery({
    initialPageParam: 1,
    queryKey: ['programs', { ...params, moduleId }],
    queryFn: async ({ pageParam = 1 }) =>
      await API.programs.getList({
        ...params,
        tabName: params.tabName ?? 'all',
        page: pageParam,
        module: moduleId,
      }),
    getNextPageParam: (lastPage, _allPages, lastPageParam) => {
      const { next } = lastPage;
      return next ? lastPageParam + 1 : undefined;
    },
    select: (data) => {
      return {
        ...data,
        results: data?.pages.flatMap((page) => page.results),
      };
    },
    enabled: Boolean(moduleId),
  });
};
